import React from 'react';
import { Button, ButtonGroup, DropdownButton, Glyphicon, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { authSelectors } from '../store/auth/authSlice';
import { connect } from 'react-redux';

class TooltipElement extends React.Component {

  state = {
    isDropdownExpand: false,
  };

  static WithOverlay = ({ children, ...props }) => {
    const { text, placement = 'bottom', isTooltipActive, disabled } = props;
    return (
      <OverlayTrigger
        placement={placement}
        overlay={isTooltipActive === undefined || isTooltipActive
          ? <Tooltip id={text}>{text}</Tooltip>
          : <React.Fragment/>}
        trigger={['hover']}
      >
        <div style={disabled ? { display: 'inline-block', cursor: 'not-allowed' } : { display: 'inline-block' }}>
          {children}
        </div>
      </OverlayTrigger>
    );
  };

  renderIconButton = ({ style, ...props }) => {
    const newStyle = {
      ...style,
      pointerEvents: props.disabled ? 'none' : 'auto',
    };
    return (
      <TooltipElement.WithOverlay {...props}>
        <Button as={ButtonGroup} {...props} style={newStyle}>
          <Glyphicon glyph={props.icon}/>
        </Button>
      </TooltipElement.WithOverlay>
    );
  };

  renderDropdownIconButton = ({ items, className, icon, id, title, style, children, ...props }) => {
    const newClassNames = className.split(' ').concat([`${props.disabled ? 'disabled' : ''}`]).join(' ');
    const newStyle = {
      ...style,
      pointerEvents: props.disabled ? 'none' : 'auto',
    };
    return (
      <TooltipElement.WithOverlay {...props} isTooltipActive={!this.state.isDropdownExpand}>
        <DropdownButton title={<Glyphicon glyph={icon}/>} id={id} className={newClassNames} style={newStyle}
                        onToggle={this.onToggle} {...props}>
          {items.map((i, index) => {
            const { divider, text, ...rest } = i;
            if (divider) return <MenuItem key={index} divider/>;

            return (
              <MenuItem key={index} {...rest}>{text}</MenuItem>
            );
          })}
        </DropdownButton>
      </TooltipElement.WithOverlay>
    );
  };

  onToggle = (isDropdownExpand) => {
    this.setState({ isDropdownExpand })
  };

  typeMapping = {
    button: this.renderIconButton,
    dropdown: this.renderDropdownIconButton,
  };

  render() {
    const { type, isUserAllowWrite, displayOnlyForWriter, ...props } = this.props;
    const Component = this.typeMapping[type];

    if (displayOnlyForWriter && !isUserAllowWrite) {
      return null;
    }

    return <Component {...props}/>;
  }
}

const mapStateToProps = (state) => ({
  isUserAllowWrite: authSelectors.allowWrite(state),
})

export default connect(mapStateToProps)(TooltipElement);



// WEBPACK FOOTER //
// ./src/components/tooltipElement.js